import { InvalidCredentialsError } from "../../../domain/errors/invalid-credentials-error";
import { UnexpectedError } from "../../../domain/errors/unexpected-error";
import { Iss } from "../../../domain/models/iss";
import { HttpClient, HttpStatusCode } from "../../protocols/http/http-client";

export class RemoteIss implements Iss {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient
  ) {}

  async calculate(companyId: number, nationalServiceId: number): Promise<any> {
    const httpResponse = await this.httpClient.request({
      url: `${this.url}/calculate`,
      method: "get",
      params: {
        companyId,
        nationalServiceId,
      },
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }

  async filter(params: any): Promise<any> {
    const httpResponse = await this.httpClient.request({
      url: `${this.url}/filter`,
      method: "get",
      params,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }

  async create(body: any): Promise<any> {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: "post",
      body,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.created:
        return httpResponse.body;
      default:
        throw new UnexpectedError();
    }
  }

  async update(id: number, body: any): Promise<any> {
    const httpResponse = await this.httpClient.request({
      url: `${this.url}/${id}`,
      method: "put",
      body,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      default:
        throw new UnexpectedError();
    }
  }

  async delete(id: number): Promise<void> {
    const httpResponse = await this.httpClient.request({
      url: `${this.url}/${id}`,
      method: "delete",
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.noContent:
      case HttpStatusCode.ok:
        return;
      default:
        throw new UnexpectedError();
    }
  }

  async loadById(id: number): Promise<any> {
    const httpResponse = await this.httpClient.request({
      url: `${this.url}/${id}`,
      method: "get",
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      default:
        throw new UnexpectedError();
    }
  }
}
